/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-donut',
  templateUrl: './widget-layers-donut.component.html',
  styleUrls: ['./widget-layers-donut.component.css']
})
export class WidgetLayersDonutComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(value: boolean) {
    this.widgetLayers.layer(this.current).change({ gaugeDonut: value });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ gaugeDonut: value }, this.current);
  }

}
